/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { OrganizationTypeResponse } from './platformapi.schemas';

import getOrganizationTypesMutator from '../custom-axios-instance';

/**
 * Retrieves a list of organization types
 * @summary Get Organization Types
 */
export const getOrganizationTypes = (signal?: AbortSignal) => {
  return getOrganizationTypesMutator<OrganizationTypeResponse[]>({
    url: `${import.meta.env['VITE_API_HOST']}/organization-types/`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationTypesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/organization-types/`] as const;
};

export const getGetOrganizationTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationTypes>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTypes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationTypes>>> = ({ signal }) =>
    getOrganizationTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationTypes>>
>;
export type GetOrganizationTypesQueryError = void;

export function useGetOrganizationTypes<
  TData = Awaited<ReturnType<typeof getOrganizationTypes>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTypes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationTypes>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationTypes<
  TData = Awaited<ReturnType<typeof getOrganizationTypes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTypes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationTypes>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationTypes<
  TData = Awaited<ReturnType<typeof getOrganizationTypes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTypes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Types
 */

export function useGetOrganizationTypes<
  TData = Awaited<ReturnType<typeof getOrganizationTypes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationTypes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationTypesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
